import { render } from "./ChildrenKindergartenView.vue?vue&type=template&id=3fd9397b&ts=true"
import script from "./ChildrenKindergartenView.vue?vue&type=script&lang=ts"
export * from "./ChildrenKindergartenView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__